export default __webpack_public_path__ + "static/media/payment.3293336a.svg";